// @flow
import React from 'react';
import './Loading.scss';

const Loading = ({ label = 'Loading', color = undefined, type = "v2", classNames = "" }) => {
    if (type === "v2") {
        return (
            <div className={`loading_v2 loading-dots loading-dots-dark ${classNames}`}>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
            </div>
        )
    }

    return (
        <div className={`loading ${classNames}`} style={color ? { color } : {}}>
            <i className="fa fa-spin fa-spinner" style={color ? { color } : {}}></i>
            <p>{label}</p>
        </div>
    );
};

Loading.displayName = 'Loading';

export default Loading;